// extracted by mini-css-extract-plugin
export default {"divider":"TeamCard_divider__NETb2","teamName":"TeamCard_teamName__jXRkh"};